import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import parse from 'html-react-parser';
import GLOBAL_CONFIG from '../../config/config';
import appGoogleTracking from '../../modules/googletracking';
import { mainLoaderToggle, navParticipationMenu, scrollToElement } from '../../modules/helpers';
import GiftContent from '../../components/Content/GiftContent/GiftContent';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

class Prize extends Component {
    //huhu

    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
        };
        this.resize = this.resize.bind(this);
    }
    resize() {
        this.setState({ isMobile: window.innerWidth <= 768 });
    }
    componentWillMount() {
        window.addEventListener("resize", this.resize);
        this.resize();
    }

    componentDidMount() {
        const { t } = this.props;
        window.scrollTo(0, 0);
        //Remove main loader
        mainLoaderToggle('hide');

        //Virtual page
        appGoogleTracking.dataLayerPush({
            'customEvent': {
                'event': 'virtual-page',
                'virtualUri': GLOBAL_CONFIG.Route.thankyou,
                'pageTitle': t('Meta.title'),
                'ParticipantId': window.PARTICIPATION_ID
            }
        });
    }

    componentWillUnmount() {
        //Remove active menu participation - mitmachen
        // navParticipationMenu(false);

        //Show mainloader
        mainLoaderToggle('show');
    }
    render() {
        console.log('this.props.promotionCampaign',this.props.promotionCampaign);
        const { t } = this.props;
        let image = {
            desktop: t('Page.Confirmation.prize.desktop'),
            mobile: t('Page.Confirmation.prize.mobile')
        };
        return (
            <div className={`content-confirmation content-confirmation__${window.PROMOTION_CAMPAIGN}`}>
                <div className="s-content-title">
                    <h1>{parse(t('Page.Prize.title'))}</h1>
                    <h2 style={{ fontSize: '24px' }}>{parse(t('Page.Prize.subtitle'))}</h2>
                    {this.state.isMobile ? (<br></br>) : (null)}
                    {/* {this.props.promotionCampaign === 'kaufland' ? ( */}
                        <h2 style={{ fontSize: '20px' }}>{parse(t('Page.Prize.paragraph'))}</h2>
                    {/* ) : null} */}
                </div>

                {this.props.promotionCampaign === 'kaufland' ? (
                    
                    <NavLink
                        to={GLOBAL_CONFIG.Route.participation}
                        exact
                        data-event="join_now"
                        data-category="Prizes Page"
                        data-action="Click on Join Now"
                        data-label="GAME_PRIZE_PART"
                        onClick={appGoogleTracking.processEventCTANavLink}
                    >
                        <div style={{width: '16em', padding: '15px'}} className="btn__container btn--primary btn--hover">
                            <span className="btn__text">
                                {t("Page.Home.linkParticipation")}
                            </span>
                        </div>
                    </NavLink>
                ) : null}
                <GiftContent imageoption={image} primaryoption={true} classModifier={image.mobile === true ? " no-mobile" : ""} />
                {this.props.promotionCampaign !== 'kaufland' ? (
                    <NavLink
                        to={GLOBAL_CONFIG.Route.participation}
                        exact
                        data-event="join_now"
                        data-category="Prizes Page"
                        data-action="Click on Join Now"
                        data-label="GAME_PRIZE_PART"
                        onClick={appGoogleTracking.processEventCTANavLink}
                    >
                        <div style={{ width: '20em', padding: '15px', marginBottom: '75px' }} className="btn__container btn--primary btn--hover">
                            <span className="btn__text">
                                {t("Page.Home.linkParticipation")}
                            </span>
                        </div>
                    </NavLink>
                ) : null}
            </div>


        );
    }

}

export default withTranslation()(Prize);